import React from 'react';
import { Map } from 'leaflet';

import ZoneCollectionLayer from './ZoneCollectionLayer';

import { styleMethods } from 'dataviz/config/map';
import { zoneIsSelected } from 'util/zoneDrawing';

import type { ParsedZone } from 'mapping/ReviewScriptMap';

interface BulkReviewLayerProps {
  map?: Map; // Inserted by Leaflet
  seedingRateBins: [number, number][];
  selectedZoneIds: string[];
  zones: Record<string, ParsedZone>;
}

/** A map layer for displaying a generated script for review. */
const BulkReviewLayer = ({ map, seedingRateBins, selectedZoneIds, zones }: BulkReviewLayerProps) => (
  <section className='bulk-review-layer'>
    <ZoneCollectionLayer
      layerName='bulk-review'
      map={map}
      styleFunction={styleMethods.seedRateForBulkReview.bind(null, seedingRateBins)}
      zoneIsSelected={zoneIsSelected.bind(null, selectedZoneIds)}
      zones={zones}
    />
  </section>
);

export default BulkReviewLayer;
